import React from 'react';
import AboutBanner from '../AboutBanner/AboutBanner';
import AboutDescription from '../AboutDescription/AboutDescription';
import ContactUs from '../ContactUs/ContactUs';
import Team from '../Team/Team/Team';

const About = () => {
    return (
        <div>
            <AboutBanner />
            <AboutDescription />
            <Team />
            <ContactUs />
        </div>
    );
};

export default About;